import { CircularProgress, Grid, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AcnColorTheme } from "../../assets/css/AcnColorTheme";
import inactiveAccounts from "../../assets/img/inactive_accounts.png";
import DynamicTitle from "../../component/DynamicTitle";
import TemplateComponent from "../../component/template/TemplateComponent";
import { AccountInfo, AccountList, AccountsRequest } from "../../models/RequestModel";
import { AccountInfoResponse, VerificationResponse } from "../../models/ResponseModel";
import { UserInfoModel } from "../../models/UserInfoModel";
import { ApiConfig, ServiceApi } from "../../service/ServiceApi";
import { RootState } from "../../store";
import { actions as UserAction } from "../../store/redux/UserInfoRedux";
import { NavTo } from "../../utils/AppManager";
import { Path } from "../../utils/Constant";
import { fontUnit, padGinUnit } from "../../utils/DeviceManager";
import { SelectAccount } from './component/SelectAccount';

export function ManageAccountScreen(props: any) {
    const dispatch = useDispatch();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

    const [message, setMessage] = useState("")
    const [isInactiveAccount, setIsInactiveAccount] = useState(false)
    const [userInfo] = useSelector((state: RootState) => [
        state.userInfoReducer.userInfo,
    ]);
    const [requesting, setRequesting] = useState(false);

    const [selectedAcc, setSelectedAcc] = useState<AccountInfoResponse[]>([]);

    const isAtLeastOne = () => {
        const isRange = selectedAcc.filter((item) => {
            return item.registered
        }).length
        return isRange >= 1 && isRange <= 9
    }

    const onRegAccounts = async (request: AccountList) => {
        setRequesting(true)
        await axios.post(ServiceApi.REG_ACCOUNT, request, ApiConfig).then((res) => {
            return res;
        }).then(data => {
            const res: VerificationResponse = data.data
            if (res.accessToken === userInfo.accessToken) {
                NavTo(Path.success, Path.mng_chg);
            }
            setRequesting(false)
        })
            .catch(error => {
                const errorStr = JSON.stringify(error)
                console.log(errorStr)
                setMessage("ขออภัย ไม่สามารถแสดงผลลัพธ์ได้ในขณะนี้ กรุณาลองอีกครั้ง")
                setRequesting(false)
            })
    }

    const onGetAccounts = async (request: AccountsRequest) => {
        setRequesting(true)
        await axios.post(ServiceApi.LIST_ACCOUNT, request, ApiConfig).then((res) => {
            return res;
        }).then(data => {
            setMessage("")
            setRequesting(false)
            const selected = data.data.accounts.map((item: AccountInfoResponse) => {
                return { ...item }
            })
            setSelectedAcc(selected)
        })
            .catch(error => {
                const errorStr = JSON.stringify(error)
                console.log(errorStr)
                setRequesting(false)
                if (error.response.status == 404) {
                    setMessage("")
                    setIsInactiveAccount(true);
                } else {
                    setMessage("ขออภัย ไม่สามารถแสดงผลลัพธ์ได้ในขณะนี้ กรุณาลองอีกครั้ง")
                }
            })
    }

    useEffect(() => {
        console.log("MESSAGE " + message)
    }, [message])

    const onConfirm = async () => {
        if (isAtLeastOne()) {
            const finalSelectedAcc: AccountInfo[] = selectedAcc.filter((item: AccountInfo) => {
                return item.registered
            }).map((item) => ({
                accountNo: item.accountNo,
                accountNoDisplay: item.accountNoDisplay,
                accountType: item.accountType,
                accountTypeName: item.accountTypeName,
                registered: item.registered,
                enable: item.enable
            }))
            const request: AccountList = { accessToken: userInfo.accessToken, accounts: finalSelectedAcc }

            onRegAccounts(request).then(() => {
                console.log("Register account")
            })
        }
    }

    useEffect(() => {
        document.title = "สมัครใช้งาน"
        if (props?.match?.params?.token) {
            const token = props.match.params.token;
            const newInfo: UserInfoModel = { ...userInfo, accessToken: token }
            UserAction.setUserInfo(dispatch, newInfo).then(() => {
                const request: AccountsRequest = { accessToken: token }
                onGetAccounts(request).then(() => {
                    console.log("Requesting user account by line")
                })
            })
        }
    }, [])

    const onLoading = () => {
        return (
            <Typography
                align={"center"}
                style={{
                    position: "relative",
                    width: "100%",
                    alignContent: "center",
                    paddingTop: 200,
                }}>
                <CircularProgress color='primary' style={{ alignSelf: "center" }} />
            </Typography>
        )
    }

    const onSelect = (accountNo: string, checked: boolean) => {
        const selected: AccountInfoResponse[] = selectedAcc.map((item) => {
            if (item.accountNo === accountNo) {
                return { ...item, registered: checked };
            } else return item;
        });
        setSelectedAcc(selected);
    };

    const onSelectAll = (isIndeterminate: boolean) => {
        const isAllAccountSelected = selectedAcc.every((acc) => acc.registered);
        if (isAllAccountSelected || isIndeterminate) {
            setSelectedAcc((prevState) => {
                return prevState.map((acc) => ({ ...acc, registered: false }));
            });
        } else {
            setSelectedAcc((prevState) => {
                return prevState.map((acc) => ({ ...acc, registered: true }));
            });
        }
    };

    // Case inactive account
    if (isInactiveAccount && selectedAcc.length <= 0) {
        const noAccountsWidget = () => {
            return (
                <div style={{ alignContent: "center", position: 'fixed', marginRight: '20px', width: '100%' }}>
                    <Grid container direction="column" justifyContent="center" alignItems="center">
                        <Grid item >
                            <img width={!isDesktop ? window.innerWidth : window.innerWidth * 0.3} src={inactiveAccounts} alt={"inactive-accounts"} />
                        </Grid>
                        <Grid item xs={12}>
                            <DynamicTitle title={"คุณไม่มีบัญชีให้เชื่อมต่อ"} size={32} isFull={true} color={AcnColorTheme.darkBlue} />
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 12, paddingLeft: padGinUnit(24), paddingRight: padGinUnit(24) }}>
                            <Typography style={{ color: AcnColorTheme.black, whiteSpace: 'pre-line' }}>
                                โปรดติดต่อฝ่ายบริการลูกค้า<br />
                                โทร. 02-777-7333 หากข้อมูลไม่ถูกต้อง
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            )
        }

        return <TemplateComponent content={noAccountsWidget()}
            background={AcnColorTheme.primary}
            noPadding
            showHeadBar={false}
            footerText="กดปุ่มปิดเพื่อกลับไปหน้าแชทหลัก"
        />
    }

    const accountWidget = () => {
        return (
            <div style={{ padding: '24px' }}>
                <div>
                    <DynamicTitle title={"จัดการบัญชี"} size={fontUnit(24)} isFull={true} align={"left"} isFontWeightMediumStyle />
                    <Typography align="left" style={{ fontFamily: "Prompt-Light", fontSize: fontUnit(16), marginTop: padGinUnit(8) }}>เลือกบัญชีที่ต้องการเชื่อมต่อกับ Chaiyo Connect</Typography>
                    {message && (
                        <Typography
                            align={"left"}
                            style={{
                                width: "95%", color: AcnColorTheme.secondaryRed,
                                fontSize: fontUnit(16), marginTop: padGinUnit(8)
                            }}
                        >
                            {message}
                        </Typography>
                    )}
                </div>
                {!message && <SelectAccount accounts={selectedAcc} onSelect={onSelect} onSelectAll={onSelectAll} />}
            </div>
        )
    }

    return (
        <TemplateComponent content={(requesting) ? onLoading() : accountWidget()}
            onNext={onConfirm}
            isCanNext={isAtLeastOne() && !requesting}
            nextText={"ยืนยัน"}
            noPadding />
    );
}